import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'
import range from 'lodash/range'

import { Icon } from 'src/chrome'

import styles from './Pagination.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'

interface PaginationProps {
  onPageChange: (page: number) => void
  count: number
  pagesToShow: number
  pageSize: number
  currentPage: number
}

const Pagination: React.FC<PaginationProps> = props => {
  const { onPageChange, count, pageSize, currentPage, pagesToShow } = props

  const iconColor = '#6F8394'

  const numberPages = Math.ceil(count / pageSize)
  const lowerBound =
    Math.floor((currentPage - 1) / pagesToShow) * pagesToShow + 1
  const buttonList = range(
    lowerBound,
    Math.min(lowerBound + pagesToShow, numberPages + 1),
  )

  const handleRangeChange = (type: 'previous' | 'next') => {
    onPageChange(
      type === 'previous'
        ? buttonList[0] - 1
        : buttonList[buttonList.length - 1] + 1,
    )
  }

  const handleBoundary = (direction: 'first' | 'last') => {
    switch (direction) {
      case 'first':
        onPageChange(1)
        break
      case 'last':
        onPageChange(numberPages)
        break
      default:
        break
    }
  }

  const handlePreviousClick = () => onPageChange(currentPage - 1)
  const handleNextClick = () => onPageChange(currentPage + 1)

  return (
    <div>
      {numberPages > 1 && (
        <div className={`${styles.buttonGroup}`}>
          <Tooltip title="Go to first">
            <IconButton
              disabled={props.currentPage === 1}
              onClick={() => handleBoundary('first')}
            >
              <Icon icon={'CHEVRONLEFT'} color={iconColor} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Previous">
            <IconButton
              disabled={props.currentPage === 1}
              onClick={handlePreviousClick}
            >
              <Icon icon={'CARROTLEFT'} color={iconColor} />
            </IconButton>
          </Tooltip>
          {buttonList.indexOf(1) < 0 && (
            <Button
              className={`${styles.pageButtons}`}
              onClick={() => handleRangeChange('previous')}
            >
              <Text type="body">. . .</Text>
            </Button>
          )}
          {buttonList.map(page => {
            return (
              <div key={page}>
                <Button
                  className={`${styles.pageButtons}`}
                  style={
                    page === props.currentPage
                      ? { color: '#e841b3', fontWeight: 'bold' }
                      : {}
                  }
                  onClick={() => onPageChange(page)}
                >
                  <Text
                    type="body"
                    color={
                      page === props.currentPage
                        ? 'primaryBrand'
                        : 'primaryBody'
                    }
                    weight={page === props.currentPage ? 'bold' : 'regular'}
                  >
                    {page}
                  </Text>
                </Button>
              </div>
            )
          })}
          {buttonList.indexOf(numberPages) < 0 && (
            <Button
              className={`${styles.pageButtons}`}
              onClick={() => handleRangeChange('next')}
            >
              <Text type="body">. . .</Text>
            </Button>
          )}
          <Tooltip title="Next">
            <IconButton
              onClick={handleNextClick}
              disabled={props.currentPage === numberPages}
            >
              <Icon icon={'CARROTRIGHT'} color={iconColor} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Go to end">
            <IconButton
              disabled={props.currentPage === numberPages}
              onClick={() => handleBoundary('last')}
            >
              <Icon icon={'CHEVRONRIGHT'} color={iconColor} />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  )
}

export default Pagination
